import React from 'react'
import "../../styles/FAQ.css"

function FAQ() {
  return (
    <div className="faq-section">
        
	    <details open>
		    <summary>
				¿Cuáles son los servicios de consultoría financiera que ofrecen?
		    </summary>
		    <div>
				Proporcionamos una gama completa de servicios de consultoría financiera, 
				incluyendo planificación tributaria, asesoramiento contable y estrategias de inversión.
		    </div>
	    </details>
		<details>
		    <summary>
				¿Cómo pueden ayudarme con la planificación tributaria?
		    </summary>
		    <div>
				Nuestros expertos en tributación pueden evaluar tu situación financiera y ayudarte a desarrollar estrategias 
				de planificación tributaria que optimicen tus impuestos de manera legal y eficiente.
		    </div>
	    </details>
	    <details>
		    <summary>
				¿Cuál es su experiencia en asesoramiento para negocios?
		    </summary>
		    <div>
				Contamos con años de experiencia trabajando con empresas de diferentes tamaños e industrias, 
				brindando asesoramiento en áreas como optimización de costos, análisis financiero y cumplimiento normativo.
		    </div>
	    </details>
	    <details>
		    <summary>
				¿Ofrecen servicios de contabilidad para particulares?
		    </summary>
		    <div>
				Sí, ofrecemos servicios de contabilidad tanto para individuos como para negocios, 
				incluyendo declaración de impuestos, preparación de estados financieros y más.
		    </div>
	    </details>
		<details>
		    <summary>
				¿Pueden ayudarme con la declaración de impuestos personales?
		    </summary>
		    <div>
				Definitivamente. Nuestro equipo puede ayudarte a preparar y presentar tus declaraciones de impuestos personales, 
				asegurándonos de que aproveches todas las deducciones y créditos disponibles.
		    </div>
	    </details>
	    <details>
		    <summary>
				¿Qué ventajas fiscales puedo obtener al invertir con su orientación?
		    </summary>
		    <div>
				Al invertir con nuestro asesoramiento, puedes acceder a estrategias fiscales específicas que pueden 
				minimizar la carga tributaria en tus inversiones y maximizar tus rendimientos netos.
		    </div>
	    </details>
	    <details>
		    <summary>
				¿Cómo puedo ponerme en contacto con su equipo para obtener asesoramiento financiero personalizado?
		    </summary>
		    <div>
				Puedes comunicarte con nosotros a través de esta sección de contacto, ya sea por teléfono via whatsapp o correo electrónico. 
				También ofrecemos consultas en persona para discutir tus necesidades y objetivos financieros.
		    </div>
	    </details>
		<details>
		    <summary>
				¿Cuál es el proceso típico de colaboración con su empresa en cuestiones fiscales y financieras?
		    </summary>
		    <div>
				Nuestro proceso de colaboración suele comenzar con una consulta inicial para comprender tus necesidades y objetivos. 
				A partir de ahí, trabajaremos contigo para desarrollar un plan personalizado que aborde tus desafíos fiscales y 
				financieros específicos. Esto puede incluir análisis detallados, recomendaciones estratégicas y seguimiento continuo 
				para garantizar que estés en el camino correcto hacia tus metas.
		    </div>
	    </details>
	    <details>
		    <summary>
                ¿Qué métodos de pago aceptan?
		    </summary>
		    <div>
                Aceptamos tarjetas de crédito y PayPal como formas de pago...
		    </div>
	    </details>
	    <details>
		    <summary>
                ¿Cómo creo una cuenta?
		    </summary>
		    <div>
                Puedes contactar a nuestro equipo de soporte a través del formulario en esta página...
		    </div>
	    </details>
		
    </div>
  )
}

export default FAQ